import React from 'react';
import { motion } from 'framer-motion';
import { pageTransition, pageVariants } from '../../constants/pageMotion';

const MOTION_COMPONENTS = {
  div: motion.div,
  section: motion.section
};

export default function AnimatedPage({
  as = 'div',
  children,
  className = '',
  transition = pageTransition,
  variants = pageVariants
}) {
  const Component = MOTION_COMPONENTS[as] ?? motion.div;

  return (
    <Component
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={transition}
      className={className}
    >
      {children}
    </Component>
  );
}
